const initialState = {
  data : [{
    room: 'Default',
    guest1:[],
    guest2:[]
  }],
  roomName:'',
  selRoom:'Default',
  selIndex:0,
  switchuser:false
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {

    case "ADD_CHATROOM":

    console.log('Inside Add chatroom');
     var newguest1 = [];
     var newguest2 = [];

       const newData = {
         room:action.roomName,
         guest1:newguest1,
         guest2:newguest2
       }

      const temp =  [...newState.data,newData];
      return {
        data: temp,
        roomName:'',
        selRoom:'Default',
        selIndex:newState.selIndex
      }

      break;

    case "SELECTCHAT_ROOM":

          console.log('Inside Select Chat Room')
          console.log(newState);
          console.log(action.selRoom);
          console.log(action.selIndex);

          return {
            data: newState.data,
            roomName:'',
            selRoom:action.selRoom,
            selIndex:action.selIndex
          }

         break;

    case "PING_GUEST1":
          console.log('action.pingChat');
          const tempState = newState;

          let tempGuest1;

          if (newState.data[newState.selIndex].guest1.length <= 0) {
            console.log('Inside of If');
             tempGuest1 = [action.pingChat];
          } else {
             tempGuest1 = [...newState.data[newState.selIndex].guest1,action.pingChat]
          }

           const newDatatmp = {
             room:newState.data[newState.selIndex].room,
             guest1:tempGuest1,
             guest2:tempGuest1
          }

             newState.data[newState.selIndex] = newDatatmp;
         
          return {
            data:newState.data,
            roomName:newState.roomName,
            selRoom:newState.selRoom,
            selIndex:newState.selIndex
          }

          break;

    case "PING_GUEST2":
          
          console.log('Inside Ping Guest2');

          let tempGuest2;

          if (newState.data[newState.selIndex].guest2.length <= 0) {
            console.log('Inside of If');
             tempGuest2 = [action.pingChat];
          } else {
             tempGuest2 = [...newState.data[newState.selIndex].guest2,action.pingChat]
          }

           const newDatatmp12 = {
             room:newState.data[newState.selIndex].room,
             guest1:tempGuest2,
             guest2:tempGuest2
          }

            newState.data[newState.selIndex] = newDatatmp12;
         
          return {
            data:newState.data,
            roomName:newState.roomName,
            selRoom:newState.selRoom,
            selIndex:newState.selIndex
          }

          break;

         case "SWTICH_USER":

            return {
            data:newState.data,
            roomName:newState.roomName,
            selRoom:newState.selRoom,
            selIndex:newState.selIndex,
            switchuser:!newState.switchuser
          }


         break;
  }
  return newState;
};

export default reducer;
